import { render, staticRenderFns } from "./SelectRecipientManually.vue?vue&type=template&id=a8608dd6"
import script from "./SelectRecipientManually.vue?vue&type=script&lang=ts"
export * from "./SelectRecipientManually.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports